
export default {
    name: 'Blank',
}
